<template>
  <div id="spinner" class="">
    <em class="ci ci-loading"></em>
  </div>
</template>
<script>
export default {
  name: 'g-spinner',
  mounted () {
    document.body.appendChild(this.$el)
  }
}
</script>
<style>
  #spinner {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(22, 22, 22, 0.7);
    z-index: 800;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
  }

  #spinner.open {
    display: flex;
  }

  #spinner.close {
    display: none;
  }

  #spinner > .ci-loading::before  {
    width: 45px;
    height: 45px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/components/GSpinner.vue